import { FC } from 'react';
import { CanjeStatus } from './useCanjeStatus';
import { Breadcrumb, Tag } from '../shared/Breadcrumb';

type Props = {
  status: CanjeStatus;
};

const TAGS: Tag<CanjeStatus>[] = [
  {
    title: 'Contacto',
    start: CanjeStatus.INICIAL,
    end: CanjeStatus.FORMULARIO,
  },
  {
    title: 'Resumen',
    start: CanjeStatus.OTP,
    end: CanjeStatus.OTP,
    exceptionalCases: [CanjeStatus.ERROR_OTP_STATUS],
  },
  {
    title: 'Confirmación',
    start: CanjeStatus.ESPERANDO_RESPUESTA_CANJE,
    end: CanjeStatus.ERROR,
  },
];

export const CanjeBreadcrumb: FC<Props> = ({ status }) => {
  return <Breadcrumb status={status} tags={TAGS} />;
};
